import React, { useState } from "react";
import DatePicker, { DateObject } from "react-multi-date-picker";

export default function CustomizingConjunction() {
  const [startDate, setStartDate] = useState<any>(new DateObject());
  const handleChange = (date: any) => {
    setStartDate(date);
  };

  return <DatePicker inputClass="form-control" multiple dateSeparator="::" value={startDate} onChange={handleChange} />;
}
